import { cn } from '@lib/cn';

import type { ReactNode } from 'react';

/**
 * The cells both Feature Activation tables share.
 *
 * Headers sit on the card's own surface, not on the sunken band the clients
 * table uses: the design draws them white, divided from the rows by a hairline.
 */

export function Th({ children }: { children: ReactNode }) {
    return (
        <th className="whitespace-nowrap border-b border-line-subtle px-[18px] py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-content-muted">
            {children}
        </th>
    );
}

export function Td({ children, className }: { children?: ReactNode; className?: string }) {
    return (
        <td className={cn('border-b border-line-subtle px-[18px] py-3.5', className)}>
            {children}
        </td>
    );
}
